













import Vue from 'vue'
import PlanningPage from '@/pages/PlanningPage.vue'

interface ComponentData {
  showDialog: boolean
}

export default Vue.extend({
  name: 'PlanningWrapper',

  components: {
    PlanningPage
  },

  data (): ComponentData {
    return {
      showDialog: false
    }
  },
  
  mounted (): void {
    if(this.$vuetify.breakpoint.smAndDown) {
      this.showDialog = true
    }
  }
})
